import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { TextField, makeStyles } from "@material-ui/core";
import axios from "axios";
import { isKorea, url, isSpecialExp, getToday } from "../../lib/Common";
const useStyles = makeStyles({
  TextField: {
    marginTop: 10,
    marginBottom: 10,
  },
  CircularDiv: {
    marginTop: 10,
    display: "flex",
    justifyContent: "center",
    marginBottom: 20,
  },
  "@media screen and (min-width:600px)": {
    CircularDiv: {
      marginBottom: 30,
    },
  },
});

function Mcs({
  partcode,
  mcsRef,
  setStyleInfo,
  setPartStock,
  setPartStockInfo,
  setLoading,
}) {
  const classes = useStyles();
  const [errorText, setErrorText] = useState("");
  const [errorValue, setErrorValue] = useState(false);
  const currentday = getToday();
  const handleMcsValidate = (value) => {
    if (isKorea.test(value) || isSpecialExp.test(value)) {
      setErrorText("숫자 / 영문만 입력 가능합니다.");
      setErrorValue(true);
      mcsRef.current.focus();
      mcsRef.current.value = "";
    } else if (value.length === 0) {
      setErrorText("");
      setErrorValue(false);
    } else if (
      value.length !== 16 &&
      value.length !== 10 &&
      value.length !== 9
    ) {
      setErrorText("16글자 또는 10글자 또는 9글자 데이터 입력하세요.");
      setErrorValue(true);
    } else {
      setErrorText("");
      setErrorValue(false);
      validateName(value);
    }
  };

  const validateName = async (value) => {
    let urlCheck = url + "/api/specialMember/SpecialStockAmt";
    let styleno = "";
    let colorcode = "";
    let sizecode = "";
    setLoading(true);
    value = value.toUpperCase();
    try {
      if (value.length === 16) {
        styleno = value.substr(0, 3) + value.substr(5, 5);
        colorcode = value.substr(10, 3).trim();
        sizecode = value.substr(13, 3);
      } else {
        if (value.length === 9) {
          styleno = value.substr(0, 3) + value.substr(5, 4) + "0";
        } else {
          styleno = value.substr(0, 3) + value.substr(5, 5);
        }
        colorcode = "%";
        sizecode = "%";
      }
 
      const response = await axios.post(
        urlCheck,
        {
          partcode,
          styleno,
          colorcode,
          sizecode,
          currentday,
        },
        { withCredentials: true }
      );
      if (
        response.data.styleInfo.amt === "-1" ||
        response.data.styleInfo.tagprice === "-1"
      ) {
        throw new Error("-1");
      } else if (response.data.styleInfo.amt === "-2") {
        throw new Error("-2");
      } else {
        setStyleInfo(response.data.styleInfo);
        setPartStock(response.data.partStock);
        setPartStockInfo(response.data.partStockInfo);
      }
      setErrorValue(false);
      setLoading(false);
      mcsRef.current.focus();
    } catch (e) {
      if (e.message === "-1") {
        alert("잘못된 품번 혹은 값이 정상적이지 않습니다.");
      } else {
        console.log(e);
        
        alert("작동 가능 시간이 아닙니다. ( 특판 담당자 한테 문의 바랍니다. )");
      }
      setStyleInfo(null);
      setPartStock(null);
      setPartStockInfo(null);
      setLoading(false);
    }
  };
  return (
    <Fragment>
      <TextField
        className={classes.TextField}
        autoFocus
        required
        fullWidth
        autoComplete="off"
        inputRef={mcsRef}
        error={errorValue}
        helperText={errorText}
        label="품번입력"
        type="text"
        variant="filled"
        onBlur={(e) => {
          handleMcsValidate(e.target.value);
        }}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            handleMcsValidate(e.target.value);
          }
        }}
        inputProps={{
          maxLength: 16,
        }}
        name="mcs"
        defaultValue=""
      />
    </Fragment>
  );
}

Mcs.propTypes = {
  McsRef: PropTypes.object,
  mcs: PropTypes.string,
  onChangeMcs: PropTypes.func,
};

export default Mcs;
